import { useQuery } from '@tanstack/react-query';
import { useAuthorization } from 'components/Authorization';
import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { StoreAuthErrorCount } from 'services/api/admin';
import { queries } from 'services/queries';

export const authShopErrorCountState = atom<StoreAuthErrorCount>({
  shopeeAuthExceptionNum: 0,
  lazadaAuthExceptionNum: 0,
  tokopediaAuthExceptionNum: 0,
  tiktokAuthExceptionNum: 0,
  shopeeLocalRegisterExceptionNum: 0,
  aliExpressAuthExceptionNum: 0,
  lazadaAuthBeAboutExpireNum: 0,
  shopeeAuthBeAboutExpireNum: 0,
  tiktokAuthBeAboutExpireNum: 0,
  tiktokPermissionExceptionNum: 0,
  tiktokNoCsatPermissionNum: 0,
  tokopediaAuthBeAboutExpireNum: 0,
  aliExpressAuthBeAboutExpireNum: 0,
  tiktokUsAuthBeAboutExpireNum: 0,
  tiktokUsAuthExceptionNum: 0,
  tiktokUsPermissionExceptionNum: 0,
  tiktokUsNoCsatPermissionNum: 0,
  mercadoAuthBeAboutExpireNum: 0,
  mercadoAuthExceptionNum: 0,
  kwaiAuthBeAboutExpireNum: 0,
  kwaiAuthExceptionNum: 0,
  tokopediaMigrateTiktokNotAuthNum: 0,
});

const useAuthShopErrorCount = () => {
  const auth = useAuthorization<Oversea.Token.Payload>();
  const [errorCount, setAuthShopErrorCount] = useAtom(authShopErrorCountState);
  const orgId = auth?.payload?.orgId;

  const { data: result, refetch: getErrorCount } = useQuery({
    ...queries.stores.authErrorCount(orgId!),
    enabled: !!orgId,
  });

  useEffect(() => {
    if (result) {
      setAuthShopErrorCount(result.data.data);
    }
  }, [result, setAuthShopErrorCount]);

  return {
    getErrorCount,
    errorCount,
  };
};

export default useAuthShopErrorCount;
